import { render, staticRenderFns } from "./openTariningRooms.vue?vue&type=template&id=115cb9cf&scoped=true"
import script from "./openTariningRooms.vue?vue&type=script&lang=js"
export * from "./openTariningRooms.vue?vue&type=script&lang=js"
import style0 from "./openTariningRooms.vue?vue&type=style&index=0&id=115cb9cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115cb9cf",
  null
  
)

export default component.exports